import { axiosGet, axiosPost } from "../../../redux/setupAxios";

export function resetPassword(data) {
  return axiosPost("/reset-password", data);
}

export function getFile(data) {
  return axiosGet(`/file/${data}`);
}
